(function () {
  if (window.__uptreandUtilityBar) return;
  window.__uptreandUtilityBar = true;

  var KEY = 'uptreand_pin';
  var EXACT = {
    '403': 'Goa',
    '605': 'Puducherry',
    '737': 'Sikkim',
    '744': 'Andaman & Nicobar Islands'
  };
  var REGION = {
    11: 'Delhi', 12: 'Haryana', 13: 'Haryana',
    14: 'Punjab', 15: 'Punjab', 16: 'Punjab',
    17: 'Himachal Pradesh', 18: 'Jammu & Kashmir', 19: 'Jammu & Kashmir',
    20: 'Uttar Pradesh', 21: 'Uttar Pradesh', 22: 'Uttar Pradesh', 23: 'Uttar Pradesh',
    24: 'Uttarakhand / Uttar Pradesh', 25: 'Uttar Pradesh',
    26: 'Uttarakhand / Uttar Pradesh', 27: 'Uttar Pradesh', 28: 'Uttar Pradesh',
    30: 'Rajasthan', 31: 'Rajasthan', 32: 'Rajasthan', 33: 'Rajasthan', 34: 'Rajasthan',
    36: 'Gujarat', 37: 'Gujarat', 38: 'Gujarat', 39: 'Gujarat',
    40: 'Maharashtra', 41: 'Maharashtra', 42: 'Maharashtra', 43: 'Maharashtra', 44: 'Maharashtra',
    45: 'Madhya Pradesh', 46: 'Madhya Pradesh', 47: 'Madhya Pradesh', 48: 'Madhya Pradesh',
    49: 'Chhattisgarh',
    50: 'Telangana', 51: 'Andhra Pradesh', 52: 'Andhra Pradesh', 53: 'Andhra Pradesh',
    56: 'Karnataka', 57: 'Karnataka', 58: 'Karnataka', 59: 'Karnataka',
    60: 'Tamil Nadu', 61: 'Tamil Nadu', 62: 'Tamil Nadu', 63: 'Tamil Nadu', 64: 'Tamil Nadu',
    67: 'Kerala', 68: 'Kerala', 69: 'Kerala',
    70: 'West Bengal', 71: 'West Bengal', 72: 'West Bengal', 73: 'West Bengal', 74: 'West Bengal',
    75: 'Odisha', 76: 'Odisha', 77: 'Odisha',
    78: 'Assam', 79: 'North East India',
    80: 'Bihar', 81: 'Jharkhand', 82: 'Jharkhand', 83: 'Jharkhand', 84: 'Bihar', 85: 'Bihar'
  };

  function regionFor(pin) {
    return EXACT[pin.slice(0, 3)] || REGION[parseInt(pin.slice(0, 2), 10)] || '';
  }

  function read() {
    try {
      return localStorage.getItem(KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function write(pin) {
    try {
      localStorage.setItem(KEY, pin);
    } catch (e) {
      /* private mode — the label simply resets next visit */
    }
  }

  function paint(pin, msgEl) {
    var region = regionFor(pin);
    document.querySelectorAll('[data-ub-pin-value]').forEach(function (el) {
      el.textContent = pin;
      el.removeAttribute('data-ub-pin-empty');
    });
    if (msgEl) {
      msgEl.removeAttribute('data-state');
      msgEl.textContent = region
        ? 'We deliver to ' + pin + ' · ' + region + '.'
        : 'We deliver to ' + pin + '.';
    }
  }

  function init() {
    var saved = read();
    if (/^[1-9][0-9]{5}$/.test(saved)) {
      paint(saved, null);
      document.querySelectorAll('[data-ub-pin-input]').forEach(function (el) {
        el.value = saved;
      });
    }

    document.querySelectorAll('[data-ub-pin-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = form.querySelector('[data-ub-pin-input]');
        var msg = form.parentNode.querySelector('[data-ub-pin-msg]');
        var pin = (input.value || '').replace(/\D/g, '');
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          msg.setAttribute('data-state', 'error');
          msg.textContent = 'Please enter a valid 6-digit Indian PIN code.';
          return;
        }
        write(pin);
        paint(pin, msg);
      });
    });

    // Header search: the category selector browses a category when the search
    // box is empty, and steps aside as soon as the shopper types, because
    // Shopify's built-in search cannot be restricted to one collection.
    var form = document.querySelector('[data-mkt-search]');
    var scope = form && form.querySelector('[data-mkt-scope]');
    var query = form && form.querySelector('[data-mkt-query]');

    if (form && scope && query) {
      query.addEventListener('input', function () {
        if (query.value.trim() !== '') scope.value = '';
      });

      scope.addEventListener('change', function () {
        if (scope.value && query.value.trim() === '') window.location.href = scope.value;
      });

      form.addEventListener('submit', function (event) {
        if (scope.value && query.value.trim() === '') {
          event.preventDefault();
          window.location.href = scope.value;
        }
      });
    }

    document.addEventListener('click', function (event) {
      document.querySelectorAll('.ub__disclosure[open]').forEach(function (d) {
        if (!d.contains(event.target)) d.open = false;
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.ub__disclosure[open]').forEach(function (d) {
        d.open = false;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
